 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVERIMAGE from '@/components/CoverImage'
 import BACKEDBIRDSFRONT_1 from '@/components/Backed/birdsfront_1'
 import LOVE_1 from '@/components/love_1'
 import UNTITLED2 from '@/components/Untitled2'
 import UNTITLED21 from '@/components/Untitled21'
 import UNTITLED22 from '@/components/Untitled22'
 import UNTITLED23 from '@/components/Untitled23'
 import UNTITLED24 from '@/components/Untitled24'
 import UNTITLED25 from '@/components/Untitled25'
 import UNTITLED26 from '@/components/Untitled26'
 import UNTITLED27 from '@/components/Untitled27'
 import UNTITLED28 from '@/components/Untitled28'
 import UNTITLED29 from '@/components/Untitled29'
 import UNTITLED210 from '@/components/Untitled210'
 import UNTITLED211 from '@/components/Untitled211'
 import UNTITLED212 from '@/components/Untitled212'
 import UNTITLED213 from '@/components/Untitled213'
 import UNTITLED214 from '@/components/Untitled214'
 import UNTITLED215 from '@/components/Untitled215'
 import UNTITLED216 from '@/components/Untitled216'
 import UNTITLED217 from '@/components/Untitled217'
 import UNTITLED218 from '@/components/Untitled218'
 import UNTITLED219 from '@/components/Untitled219'
 import UNTITLED220 from '@/components/Untitled220'
 import UNTITLED221 from '@/components/Untitled221'
 import UNTITLED222 from '@/components/Untitled222'
 import UNTITLED223 from '@/components/Untitled223'
 import UNTITLED224 from '@/components/Untitled224'
 import LOVE_2 from '@/components/love_2'
 import UNTITLED225 from '@/components/Untitled225'
 import BACKEDBACKAD_1 from '@/components/Backed/backad_1'
 import BACKEDORIMAD_1 from '@/components/Backed/ORIMad_1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/CoverImage",
 			"name" : "CoverImage",
 			"component" : COVERIMAGE
 		},
 		{
 			"path" : "/Backed/birdsfront_1",
 			"name" : "Backed/birdsfront_1",
 			"component" : BACKEDBIRDSFRONT_1
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Untitled2",
 			"name" : "Untitled2",
 			"component" : UNTITLED2
 		},
 		{
 			"path" : "/Untitled21",
 			"name" : "Untitled21",
 			"component" : UNTITLED21
 		},
 		{
 			"path" : "/Untitled22",
 			"name" : "Untitled22",
 			"component" : UNTITLED22
 		},
 		{
 			"path" : "/Untitled23",
 			"name" : "Untitled23",
 			"component" : UNTITLED23
 		},
 		{
 			"path" : "/Untitled24",
 			"name" : "Untitled24",
 			"component" : UNTITLED24
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js